export const exitBrowserFullscreen = async (): Promise<void> => {
  if (document.fullscreenElement) {
    return document.exitFullscreen().catch(err => {
      console.warn('Failed to exit browser fullscreen:', err);
      document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', keyCode: 27 }));
      return Promise.resolve();
    });
  }

  return Promise.resolve();
};
